function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var FETCH_CUSTOMER_CONTENT_ACTIVITY = {
  BEGIN: 'FETCH_CUSTOMER_CONTENT_ACTIVITY_BEGIN',
  SUCCESS: 'FETCH_CUSTOMER_CONTENT_ACTIVITY_SUCCESS',
  FAILURE: 'FETCH_CUSTOMER_CONTENT_ACTIVITY_FAILURE'
};
var FETCH_CUSTOMER_CONTENT_ACTIVITY_TYPES = [FETCH_CUSTOMER_CONTENT_ACTIVITY.BEGIN, FETCH_CUSTOMER_CONTENT_ACTIVITY.SUCCESS, FETCH_CUSTOMER_CONTENT_ACTIVITY.FAILURE];
export var CANCEL_CONTENT_ACTIVITY = {
  BEGIN: 'CANCEL_CONTENT_ACTIVITY_TYPES_BEGIN',
  SUCCESS: 'CANCEL_CONTENT_ACTIVITY_TYPES_SUCCESS',
  FAILURE: 'CANCEL_CONTENT_ACTIVITY_TYPES_FAILURE'
};
var CANCEL_CONTENT_ACTIVITY_TYPES = [CANCEL_CONTENT_ACTIVITY.BEGIN, CANCEL_CONTENT_ACTIVITY.SUCCESS, CANCEL_CONTENT_ACTIVITY.FAILURE];
export var fetchCustomerContentActivityPromise = function fetchCustomerContentActivityPromise(dispatch, customerId) {
  var additionalParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ThunkHelper(dispatch, FETCH_CUSTOMER_CONTENT_ACTIVITY_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SearchContentActivity',
    data: Object.assign({
      IncludeDownloads: true,
      SortDirection: 2
    }, additionalParams),
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var fetchCustomerContentActivity = function fetchCustomerContentActivity(customerId, additionalParams) {
  return function (dispatch) {
    return fetchCustomerContentActivityPromise(dispatch, customerId, additionalParams);
  };
};
export var cancelContentActivityPromise = function cancelContentActivityPromise(dispatch, customerId, params) {
  return ThunkHelper(dispatch, CANCEL_CONTENT_ACTIVITY_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CloseContentViews',
    data: params,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var cancelContentActivity = function cancelContentActivity(customerId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    return cancelContentActivityPromise(dispatch, customerId, params);
  };
};
export var SET_ACTIVE_IS_SELECTED = 'SET_ACTIVE_IS_SELECTED';
export var setActiveIsSelected = function setActiveIsSelected(activeIsSelected) {
  return {
    type: SET_ACTIVE_IS_SELECTED,
    payload: activeIsSelected
  };
};
export var SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export var setCurrentPage = function setCurrentPage(currentPage) {
  return {
    type: SET_CURRENT_PAGE,
    payload: currentPage
  };
};
export var SET_SELECTED_CONTENT_ACTIVITY = 'SET_SELECTED_CONTENT_ACTIVITY';
export var setSelectedContentActivity = function setSelectedContentActivity(contentActivityId) {
  return {
    type: SET_SELECTED_CONTENT_ACTIVITY,
    payload: contentActivityId
  };
};
export var SET_CONTENT_ACTIVITY_PAGE_SIZE_PREFERENCE = 'SET_CONTENT_ACTIVITY_PAGE_SIZE_PREFERENCE';
export var setPageSizePreference = function setPageSizePreference(pageSize) {
  return {
    type: SET_CONTENT_ACTIVITY_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};
export var RESET_CONTENT_ACTIVITY_RECOVERABLE = 'RESET_CONTENT_ACTIVITY_RECOVERABLE';
export var resetContentActivityRecoverable = function resetContentActivityRecoverable() {
  return {
    type: RESET_CONTENT_ACTIVITY_RECOVERABLE
  };
};
export var SHOW_BACK_BANNER = 'SHOW_BACK_BANNER';
export var showBackBanner = function showBackBanner(showBanner) {
  return {
    type: SHOW_BACK_BANNER,
    payload: showBanner
  };
};
export var EMPTY_CONTENT_ACTIVITY_LIST = 'EMPTY_CONTENT_ACTIVITY_LIST';
export var emptyContentActivityList = function emptyContentActivityList() {
  return {
    type: EMPTY_CONTENT_ACTIVITY_LIST
  };
};
export var REMOVE_CONTENT_ACTIVITY_FILTER = 'REMOVE_CONTENT_ACTIVITY_FILTER';
export var removeContentActivityFilter = function removeContentActivityFilter() {
  return {
    type: REMOVE_CONTENT_ACTIVITY_FILTER
  };
};